import http from "../utils/axios";

export const yhOrder = data => {
  return http({
    url: "/api/yh_order/getOrder", // 接口
    method: "post",
    data: data
  });
};
export const yhEmployee = data => {
  return http({
    url: "/api/yh_order/getEmployee", // 接口
    method: "post",
    data: data
  });
};

//获取统计页面数据
export const yhData = data => {
    return http({
      url: "/api/data/getList", // 接口
      method: "post",
      data: data
    });
  };